import { TimeFrames } from '@shared/types/frontend/searchHome';
import { useRouter } from 'next/router';
import { ChevronDown } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
interface FilterTimeFrameSelectorProps {
  timeFrame: TimeFrames;
  setTimeFrame: (_: TimeFrames) => void;
  customHandler?: boolean;
}
const FilterTimeFrameSelector = ({
  timeFrame,
  setTimeFrame,
  customHandler
}: FilterTimeFrameSelectorProps) => {
  const _timeFrames: TimeFrames[] = ['24', '12', '4', '1'];
  const router = useRouter();
  const handleToggle = (value: TimeFrames) => {
    setTimeFrame(value);
    if (!customHandler) router.push({
      pathname: '/home',
      query: {
        ...router.query,
        timeframe: value
      }
    }, undefined, {
      shallow: true
    });
  };
  return <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="FilterTimeFrameSelector" data-sentry-source-file="FilterTimeFrameSelector.tsx">
      <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="FilterTimeFrameSelector.tsx">
        <Button variant='blue' className='flex gap-2 items-center rounded-full w-fit h-[32px] px-[7px] py-[3px]' data-sentry-element="Button" data-sentry-source-file="FilterTimeFrameSelector.tsx">
          <p>{timeFrame} H</p>
          <ChevronDown className='w-[12px] h-[12px]' data-sentry-element="ChevronDown" data-sentry-source-file="FilterTimeFrameSelector.tsx" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='border-genius-blue bg-genius-indigo w-[154px] z-[3000]' data-sentry-element="DropdownMenuContent" data-sentry-source-file="FilterTimeFrameSelector.tsx">
        {_timeFrames.map(timeframe => <DropdownMenuItem key={timeframe} onSelect={() => handleToggle(timeframe)}>
            {timeframe} H
          </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>;
};
export default FilterTimeFrameSelector;